module.exports = __webpack_public_path__ + "img/Logo_UNDEF_IUA.81f3fc1e.png";